import React from 'react';
import Settings from '../../components/Settings';
import PageLayout from '../../ui/layout/PageLayout';
import './styles.css';

function SettingsPage() {
  return (
    <PageLayout title="Configurações" subtitle="Conta e preferências" primary={<Settings />} secondary={null} />
  );
}

export default SettingsPage;
